











import { Prop, Component, Vue } from "vue-property-decorator";
import { Project } from "@/api/project-api";
import { statusProject } from "@/status";

@Component({})
export default class ProjectNewStatus extends Vue {
  STATUS_INVOICE_PAID = 10;
  @Prop({ required: true }) project!: Project;
  @Prop({ default: "md" }) size!: string;

  get status() {
    if (typeof this.project.colorName === "object") {
      return {
        name: this.project.colorName.name,
        color: this.project.colorName.color
      };
    }

    if (this.project.statusProject == this.STATUS_INVOICE_PAID) {
      return {
        name: statusProject[this.project.statusProject - 1].text,
        color: "#a4a4a4"
      };
    }

    return {
      name: statusProject[this.project.statusProject - 1].text,
      color: this.project.colorName
    };
  }
}
